'use client'

import { Theme } from '@/lib/theme'
import { useUpsertUserProfile } from '@/modules/user/profile/use-upsert-user-profile'
import { useEffect } from 'react'

export function DarkModeSyncer({
  isAuthenticated,
}: {
  isAuthenticated: boolean
}) {
  const { upsertUserProfile } = useUpsertUserProfile({
    isAuthenticated,
  })

  useEffect(() => {
    global.window.__onThemeChange = (newTheme) => {
      upsertUserProfile({
        theme: (newTheme as string) || Theme.System,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}
